import { AddDeviceToOrganisationQueryArg } from '../types/query-arg';
import { AddDeviceToOrganisationQueryBody } from '../types/query-body';

export const addDeviceToOrganisationQueryBody = ({
  device: { id },
  organisationId,
}: AddDeviceToOrganisationQueryArg): AddDeviceToOrganisationQueryBody => ({
  actionType: 'AddOrganisation',
  id,
  update: { organisationId },
});
